// import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
// import 'primeflex/primeflex.css';
import "./ind.css";
import React, { Component } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';

import logo from "assets/img/innoviti-logo.png";
import {Scrollbars} from "react-custom-scrollbars";
import config from 'react-global-configuration';
import {NavLink} from "react-router-dom";

import jwt_decode from "jwt-decode";
import Moment from "react-moment";
import axios from "axios";
import {isMobile} from "react-device-detect";
import Avatar from 'react-avatar';
import { Collapse, Nav, NavDropdown, NavItem } from "react-bootstrap";
class LeftSidebar extends Component {

  constructor() {
    super();
    this.state = {
      visibleLeft: false,
      visibleRight: true,
      visibleTop: false,
      visibleBottom: false,
      visibleFullScreen: false,
      visibleCustomToolbar: false,
      width: window.innerWidth,
      user_type: '',
      userName: '',
      phone:''
    };
  }

    componentDidMount() {
        const token = localStorage.usertoken;
        try {
            const decoded = jwt_decode(token);
            this.setState({
                userName: decoded.firstName + ' ' + decoded.lastName,
                user_type: decoded.userGroupName,
                phone : decoded.phone
            });

        } catch (err) {
            console.log("expired check failed!");
        }

    }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  hideSidebar = () =>{
  this.setState({visible:false})
   this.props.UnipayParentCallback("sidebar");
  }
  render() {
    return (
      <div>
        <Sidebar visible={this.state.visibleRight} position="right" baseZIndex={0} onHide={this.hideSidebar} style={{ backgroundColor: '#fff', animation: '7s ease-in 5s slidein',padding:'0px'}} >

        <Scrollbars>
        <div className="logo" style={{textAlign:'center'}}>
          <a  href="/"  className="simple-text logo-mini" >
            <div className="logo-img">
              <img src={logo} alt="logo_image" style={{width:'65%'}}/>
            </div>
          </a>

        </div>
        <NavLink to="/admin/user-profile" onClick={this.hideSidebar}>
        <div className="col-xs-12 p-0" style={{margin:'10px 0px 20px 0px',background:'linear-gradient(134.72deg, rgba(34, 34, 212, 0.77) 0%, rgba(5, 5, 130, 0.77) 100%)'}}>
                            <div className="col-xs-3" style={{textAlign:'center',padding:'5px 0px'}}>
                                 <Avatar name={this.state.userName} color={Avatar.getRandomColor('sitebase', ['#45379B'])} size="40px" color="#45379B" fgColor="#FFF" round={true}/>
                                 <span style={{fontFamily:'Roboto',fontSize:'12px',color:'#000'}}>{this.state.user_type}</span>
                            </div>
                            <div className="col-xs-7" style={{padding:'10px 0px 0px 10px'}}>
                                 <span style={{fontSize:'16px',fontFamily:'Roboto',fontWeight:'600',color:'#fff',textTransform:'uppercase'}}>{this.state.userName}</span>
                                  <span style={{fontSize:'12px',fontFamily:'Roboto',display:'block',color:'ghostwhite'}}>{this.state.phone}</span>
                            </div>
                            <div className="col-xs-2" style={{padding:'10px 0px 0px 5px'}}>
                               <i class="fa fa-arrow-right" aria-hidden="true" style={{color:'#000'}}> </i>
                            </div>

        </div>
        </NavLink>
            <div className="col-xs-12">
            {this.props.routes.map((prop, key) => {
              if(prop.name.includes("Dashboard") || prop.name.includes("Sale") || prop.name.includes("Settlement") || prop.name.includes("Transaction"))
               {return null}
               else
                {
                return(
                 <NavLink to={prop.layout + prop.path} onClick={this.hideSidebar}>
                    <div className="col-xs-12 p-5" style={{borderBottom:'1px solid lightgrey',padding:'10px 0px'}}>
                            <div className="col-xs-3 p-0">
                                 <i className={prop.icon} style={{width:'auto',fontSize:'32px',color:'#333333'}}/>
                            </div>
                            <div className="col-xs-7 p-0">
                                 <p style={{display:'inline-block',color:'#333333'}}>{prop.name}</p>
                            </div>
                            <div className="col-xs-2">
                                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                           </div>
                    </div>
                </NavLink>

                  )}
            })
            }
</div>


<div className="col-xs-12 p-0" style={{position:'absolute',bottom:'100px',textAlign:'center'}}>
 <Nav>
          <NavItem href="/admin/logout/">
          <p style={{fontSize:'16px',fontWeight:'600',color:'red'}} >Logout</p>
  </NavItem>
  </Nav>
</div>

<div className="col-xs-12 p-0" style={{position:'absolute',bottom:'65px',textAlign:'center'}}>
          <p>App Version : 1.2.2</p>
</div>
        </Scrollbars>

        </Sidebar>

      </div>
    )
  }
}

export default LeftSidebar;